<script>
import appConfig from "@/app.config";

  import DefaultCab from "./default-cab.vue";
  import DefaultSop from "./default-sop.vue";
  import DefaultDemo from "./default-demo.vue";
  import DefaultOmn from "./default-omn.vue";
  import DefaultDist from "./default-dist.vue";
  import DefaultAvn from "./default-avn.vue";
  import DefaultMss from "./default-mss.vue";
  import NotFoundPage from "@/router/views/utility/404.vue";


export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    DefaultCab , DefaultSop, DefaultOmn, DefaultDist, DefaultAvn, DefaultMss, DefaultDemo, NotFoundPage
  },

  computed:{
    selectedComponent() {
      switch (process.env.VUE_APP_CLIENT_NAME) {
        case "cab":
          return "DefaultCab";
        case "sop":
          return "DefaultSop";
        case "omn":
          return "DefaultOmn";
        case "dist":
          return "DefaultDist";
        case "avn":
          return "DefaultAvn";
        case "mss":
          return "DefaultMss";
        case "demo":
          return "DefaultDemo";
        default:
          return "NotFoundPage"; 
      }
    }
  },

};
</script>


<template>
    <component :is="selectedComponent" />
</template>

